import { Navigate, useLocation, resolvePath } from "react-router";

// Identifica el origen de la navegación del usuario y redirecciona o renderiza el componente según el caso
// Para su correcto uso se debe utilizar el hook useCompatNavigate() en vez de useNavigate()

// Compatible con tabs unloading de Google Chrome

export const RedirectWhenNotNavigated = ({ children, redirectLink }) => {
  const location = useLocation();

  // Nota: El estado que se evalúa aquí se inserta en los redirect o hisiory.push hacia las rutas a evaluar:
  // history.push({pathname: "/ruta", state: {} })    o bien    <Redirect to={{pathname: "/ruta", state: {} }} />
  //
  // Al inicializar state se puede asumir de que existe y, por lo tanto, se llegó a la ruta mediante navegación por el sitio.

  return location.state ? { ...children } : <Navigate to={redirectLink} state={{}} />;
};
